import React from 'react';

const FLAG_WIDTH = 20;
const FLAG_HEIGHT = 14;

export function FlagES(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={FLAG_WIDTH} height={FLAG_HEIGHT}
             viewBox="0 0 28 20" aria-hidden="true" {...props}>
            <rect width="28" height="20" rx="2" fill="#c60b1e"/>
            <rect y="6" width="28" height="8" fill="#ffc400"/>
        </svg>
    );
}

export function FlagPT(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={FLAG_WIDTH} height={FLAG_HEIGHT}
             viewBox="0 0 28 20" aria-hidden="true" {...props}>
            <rect width="28" height="20" rx="2" fill="#009b3a"/>
            <polygon points="14,2.5 25.5,10 14,17.5 2.5,10" fill="#fedf00"/>
            <circle cx="14" cy="10" r="3.2" fill="#002776"/>
        </svg>
    );
}

export function FlagEN(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={FLAG_WIDTH} height={FLAG_HEIGHT}
             viewBox="0 0 28 20" aria-hidden="true" {...props}>
            <rect width="28" height="20" rx="2" fill="#b22234"/>
            <g stroke="#fff" strokeWidth="1.54">
                <path d="M0 2.31 H28 M0 5.38 H28 M0 8.46 H28 M0 11.54 H28 M0 14.62 H28 M0 17.69 H28"/>
            </g>
            <rect width="12" height="10.77" fill="#3c3b6e"/>
        </svg>
    );
}
